"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var Web_1 = require("./Web");
var rxjs_1 = require("rxjs");
var App = /** @class */ (function () {
    function App(authProvider, baseUrl) {
        this.pendingRpcCalls = new rxjs_1.BehaviorSubject(0);
        this.authProvider = authProvider;
        this.baseUrl = baseUrl;
        Web_1.Web.BASE_URL = this.baseUrl;
    }
    App.prototype.login = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.authProvider).login.apply(_a, args);
    };
    App.prototype.logout = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.authProvider).logout.apply(_a, args);
    };
    App.prototype.isAuthenticated = function () {
        return this.authProvider.isAuthenticated();
    };
    App.prototype.setAuth = function (authTokenHeader, authToken) {
        if (authTokenHeader === void 0) { authTokenHeader = 'Authorization'; }
        this.setHeader(authTokenHeader, authToken);
    };
    App.prototype.setHeader = function (key, value) {
        Web_1.Web.HEADERS[key] = value;
    };
    App.prototype.fetchMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rpc({ model: 'Menu', method: 'load' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    App.prototype.rpc = function (args, createPendingCall) {
        if (createPendingCall === void 0) { createPendingCall = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (createPendingCall) {
                    this.pendingRpcCalls.next(this.pendingRpcCalls.getValue() + 1);
                }
                return [2 /*return*/, Web_1.Web.rpc(args).finally(function () {
                        if (createPendingCall) {
                            _this.pendingRpcCalls.next(_this.pendingRpcCalls.getValue() - 1);
                        }
                    })];
            });
        });
    };
    App.prototype.onRpcError = function (callback) {
        Web_1.Web.onRpcError(callback);
    };
    App.prototype.fetchPageData = function (sources) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {};
                        return [4 /*yield*/, Promise.all(sources.map(function (source) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _a = result;
                                            _b = source.key;
                                            return [4 /*yield*/, this.rpc({
                                                    model: source.model,
                                                    method: source.method,
                                                    args: source.args,
                                                    kwargs: source.kwargs,
                                                })];
                                        case 1:
                                            _a[_b] = _c.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    App.prototype.fetchPages = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.rpc({ model: 'Pages', method: 'get' })];
            });
        });
    };
    App.prototype.fetchAppConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.fetchPages(), this.fetchMenu()])];
                    case 1:
                        configs = _a.sent();
                        return [2 /*return*/, {
                                pages: configs[0],
                                menu: configs[1],
                            }];
                }
            });
        });
    };
    return App;
}());
exports.App = App;
